import React from "react";

const EditCommonAction = ({ onClick }) => {
  return (
    <button type="button" className="btn btn-circle" onClick={() => onClick()}>
      <i className="fas fa-edit text-primary h5"></i>
    </button>
  );
};

export default EditCommonAction;
